import React from 'react';
import constants from '../../../constants';
import { useLink } from 'react-router-stack';
import { useDispatch, useSelector } from 'react-redux';
import { setIsSpinTheWheel, updateGameType } from '../../../actions/user-actions-types';
import { addGameToHistory, setMiniGamesData } from '../../../actions/mini-games-action-types';
import { dashboardBanner, dashboardBannerMobile } from '../../../constants/dashboard';
import { isSmartPhone } from '../../../utilities/helper';
import HomePageMWeb from './index_mweb';
import HomePageWeb from './index_web';

const HomePage = () => {
  const { teamName = '', isLoginModal = false } = useSelector((state: any) => state.user);
  const navigate = useLink();
  const { miniGamesList = [] } = useSelector((state: any) => state.minigames);
  const bannerImages = isSmartPhone ? dashboardBannerMobile : dashboardBanner;

  const mainCarousalConfig = {
    margin: 15,
    rewind: true,
    dots: false,
    loop: true,
    items: 1,
    autoplay: true,
    center: true,
    stagePadding: 0
  };
  const suggestionsHandler = (gameData: any) => {
    if (gameData.gameName === 'Poker') {
      navigate.push('/poker');
      dispatch(addGameToHistory(gameData));
    } else if (gameData.gameName === 'Fantasy Cricket') {
      dispatch(updateGameType(constants.GameType.FANTASY_CRICKET));
      dispatch(addGameToHistory(gameData));

      navigate.push('/fantasy', {
        title: 'Fantasy Cricket',
        gameType: constants.GameType.FANTASY_CRICKET
      });
    } else {
      dispatch(setMiniGamesData(gameData));
      navigate.push('/prizes');
    }
  };
  const dispatch = useDispatch();
  const onViewAllMatchCard = (type: any) => {
    if (type === 'cricketMatches') {
      dispatch(updateGameType(constants.GameType.FANTASY_CRICKET));
      navigate.push('/fantasy', {
        title: 'Fantasy Cricket',
        gameType: constants.GameType.FANTASY_CRICKET
      });
    }
  };
  const onClickSpinTheWheel = () => {
    dispatch(setIsSpinTheWheel(true));
  };

  return (
    <React.Fragment>
      {isSmartPhone ? (
        <HomePageMWeb
          onViewAllMatchCard={onViewAllMatchCard}
          suggestionsHandler={suggestionsHandler}
          mainCarousalConfig={mainCarousalConfig}
          bannerImages={bannerImages}
          onClickSpinTheWheel={onClickSpinTheWheel}
          teamName={teamName}
          miniGamesList={miniGamesList}
        />
      ) : (
        <HomePageWeb
          onViewAllMatchCard={onViewAllMatchCard}
          suggestionsHandler={suggestionsHandler}
          mainCarousalConfig={mainCarousalConfig}
          bannerImages={bannerImages}
          onClickSpinTheWheel={onClickSpinTheWheel}
          teamName={teamName}
          isLoginModal={isLoginModal}
          miniGamesList={miniGamesList}
        />
      )}
    </React.Fragment>
  );
};

export default HomePage;
